<div class="step-card new-input-fields tax-planning-client">
  <div class="step-card-header">
    <label style="font-weight: 700;font-family:'Poppins',sans-serif;color: #333333;">Invite additional users</label>
    <div style="font-size:12px;color:#667085;">Invite your team to your account.</div>
  </div>
  <div class="step-card-body">
    <div *ngFor="let member of inviteMembers; let i = index" class="row">
      <div class="medium-5 columns">
        <label>
          Name *
          <input type="text" [(ngModel)]="member.name" placeholder="User Name"/>
          <div class="error" *ngIf="member.name && hasDangerousContent(member.name)">Name contains invalid characters</div>
        </label>
      </div>
      <div class="medium-5 columns">
        <label>
          Email *
          <input type="text" [(ngModel)]="member.email" placeholder="User Email"/>
          <div class="error" *ngIf="member.email && hasDangerousContent(member.email)">Email contains invalid characters</div>
          <div class="error" *ngIf="member.email && !hasDangerousContent(member.email) && !isValidEmail(member.email)">Please enter a valid email</div>
        </label>
      </div>
      <div *ngIf="inviteMembers.length > 1" class="medium-2 columns">
        <i style="position: relative;top: 25px;" class="material-icons delete-icon" (click)="removeMember(i)">delete</i>
      </div>
    </div>
    <span class="pointer" (click)="addMember()" [class.disabled]="atInviteLimit" [style.opacity]="atInviteLimit ? '0.4' : '1'">
      <i class="material-icons float-left add-icon">add_circle_outline</i>
      <span class="float-left add-text">Add more users</span>
    </span>
    <div style="padding-bottom: 24px;"></div>
  </div>
</div>

<div class="step-footer">
  <div class="d-flex justify-content-end" style="gap:8px">
    <button class="button small cancel-button" (click)="skip()">Skip for now</button>
    <button class="button small" (click)="save()">Save</button>
  </div>
</div>
